module.exports = __webpack_public_path__ + "static/home1-product-page-banners-4cfee6f2acbc2b24428697b5c87a6902.png";